import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=3002bc78&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
import style0 from "../../theme/tag.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Tag.vue?vue&type=style&index=1&id=3002bc78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3002bc78",
  null
  
)

export default component.exports